import AppHeader from 'components/AppHeader'
export default {
  components: {
    AppHeader
  },
  data: function () {
    return {
      title: {
        content: '',
        startDate: null,
        endDate: null
      },
      validation: {
        hasContent: false,
        hasDate: false,
        isValidRange: true,
        isFuture: true,
        isAllClear: false
      },
      isDisabled: false
    }
  },
  watch: {
    title: {
      deep: true,
      handler () {
        const today = new Date()
        this.validation.hasContent = this.title.content.length > 0
        this.validation.isFuture = this.title.startDate > today && this.title.endDate > today
        this.validation.hasDate = !!this.startDate && !!this.endDate
        if (this.validation.hasDate) {
          this.validation.isValidRange = this.title.startDate < this.title.endDate
        }
        this.validation.isAllClear = this.validation.hasContent && this.validation.isFuture && this.validation.hasDate && this.validation.isValidRange
      }
    }
  },
  computed: {
    startDate: function () {
      let result
      if ([null, undefined, ''].includes(this.title.startDate)) {
        result = null
      } else {
        const date = new Date(this.title.startDate)
        result = date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + ('0' + date.getDate()).slice(-2)
      }
      return result
    },
    endDate: function () {
      let result
      if ([null, undefined, ''].includes(this.title.endDate)) {
        result = null
      } else {
        const date = new Date(this.title.endDate)
        result = date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + ('0' + date.getDate()).slice(-2)
      }
      return result
    }
  },
  methods: {
    registerTask: function () {
      this.isDisabled = true
      const data = {
        'task_title': this.title.content,
        'task_start_date': this.startDate,
        'task_end_date': this.endDate
      }
      const callback = () => {
        this.isDisabled = false
        this.goProposeTaskList()
      }
      this.$store.dispatch('PROPOSE_TASK_CREATE', {data: data, callback: callback})
    },
    goProposeTaskList: function () {
      this.$router.push({path: '/propose_task_list'})
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/propose-task-new.js